<script lang="typescript">
  import { words } from './words'
  import Tableau from './Tableau.svelte'

  export let name: string

  function getRandomInteger(min: number, max: number): number {
    min = Math.ceil(min)
    max = Math.floor(max)
    return Math.floor(Math.random() * (max - min + 1)) + min
  }

  function chooseWord(): string {
    const i = getRandomInteger(0, words.length - 1)
    return words[i]
  }
</script>

<main>
  <h1>{name}</h1>
  <Tableau word={chooseWord()}/>
</main>

<style>
</style>
